import { Card, Descriptions, Flex, List, Table, Timeline } from "antd"
import { Map } from "./Map"

export const Project = ({project}) => {
  return <>
    <Flex vertical gap="middle">
      <Flex gap="middle" wrap="wrap">
        <Flex vertical gap="middle" style={{flex: 1}}>
          <Card title="Details" className="small-card">
            <Descriptions column={1}>
              <Descriptions.Item label="Name">{project.name}</Descriptions.Item>
              <Descriptions.Item label="Project ID">{project.projectID}</Descriptions.Item>
              <Descriptions.Item label="Developer">{project.developer}</Descriptions.Item>
              <Descriptions.Item label="Country">{project.country}</Descriptions.Item>
              <Descriptions.Item label="Type">{project.type}</Descriptions.Item>
              <Descriptions.Item label="Crediting start">{project.creditingStart}</Descriptions.Item>
              <Descriptions.Item label="Crediting end">{project.creditingEnd}</Descriptions.Item>
              <Descriptions.Item label="Programme">{project.programme}</Descriptions.Item>
              <Descriptions.Item label="Methodology">{project.methodology}</Descriptions.Item>
            </Descriptions>
          </Card>

          <Card title="Timeline" className="small-card">
            <Timeline items={project.timeline} style={{marginTop: '7px'}} />
          </Card>
        </Flex>

        <Card title="Geolocation" className="big-card" style={{display: 'flex', flexDirection: 'column'}} bodyStyle={{flex: 1}}>
          <Map shape={project.shape} coord={project.coord} zoom={project.zoom}></Map>
        </Card>
      </Flex>

      <Flex gap="middle" wrap="wrap">
        <Card title="Documents" className="small-card">
          <List style={{marginTop: '-6px'}} dataSource={project.files} renderItem={(item) => <>
            <List.Item>
              <a rel="noreferrer" href={item.url} target="_blank" style={{flex: 1}}>{item.name}</a>
            </List.Item>
          </>} />
        </Card>

        <Card title="Units" className="big-card">
          <Table bordered style={{borderRadius: 0}} scroll={{x: true}} columns={[
            {
              title: 'Total',
              dataIndex: 'total'
            },
            {
              title: 'Unit type',
              dataIndex: 'type'
            },
            {
              title: 'Issuance date',
              dataIndex: 'issuance'
            },
            {
              title: 'Owner',
              dataIndex: 'owner'
            },
            {
              title: 'Serial ID',
              dataIndex: 'serial'
            }
          ]} pagination={false} dataSource={project.units} />
        </Card>

      </Flex>
    </Flex>
  </>
}